import availabilityRoutes from './availability.routes';

import availabilitySaveController from './controllers/availability.save.controller';
import availabilityFormController from './controllers/availability.form.controller';
import availabilityListController from './controllers/availability.list.controller';
import stockListController from './controllers/stock.list.controller';
import stockFormController from './controllers/stock.form.controller';
import availabilityBlockController from './controllers/availability.block.controller';

import availabilityListComponent from './components/availability.list.component';
import availabilityFormComponent from './components/availability.form.component';
import availabilitySaveComponent from './components/availability.save.component';
import stockListComponent from './components/stock.list.component';
import stockFormComponent from './components/stock.form.component';
import availabilityBlockComponent from './components/availability.block.component';

import availabilityModelService from './services/availability.service';

let availabilityModule = angular.module('spabooker.availability', ['spabooker.base'])
    .config(availabilityRoutes)

    .controller('availabilitySaveController', availabilitySaveController)
    .controller('availabilityFormController', availabilityFormController)
    .controller('availabilityListController', availabilityListController)
    .controller('stockListController', stockListController)
    .controller('stockFormController', stockFormController)
    .controller('availabilityBlockController', availabilityBlockController)

    .component('availabilityList', availabilityListComponent)
    .component('availabilityForm', availabilityFormComponent)
    .component('availabilitySave', availabilitySaveComponent)
    .component('stockList', stockListComponent)
    .component('stockForm', stockFormComponent)
    .component('availabilityBlock', availabilityBlockComponent)

    .factory('availabilityModelService', availabilityModelService)
    ;

export default availabilityModule.name;



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/availability/index.js